module.exports = __webpack_public_path__ + "img/ramp.4076ee77.svg";